import { createVNode as _createVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h3", null, "Save as new preset", -1)
const _hoisted_2 = { class: "input-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", null, "New preset name", -1)
const _hoisted_4 = { class: "flex justify-between flex-auto ml3" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "flex flex-auto" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "admin-panel-teambidding-custom-questions__edit ml2"
}
const _hoisted_9 = { class: "edit__header flex justify-between items-center mb2" }
const _hoisted_10 = { class: "edit__header-title" }
const _hoisted_11 = {
  key: 0,
  class: "edit__wrapper p2"
}
const _hoisted_12 = { class: "input-wrapper" }
const _hoisted_13 = { for: "text-en" }
const _hoisted_14 = { class: "input-wrapper" }
const _hoisted_15 = { for: "text-pl" }
const _hoisted_16 = { class: "input-wrapper" }
const _hoisted_17 = { class: "input-wrapper" }
const _hoisted_18 = { for: "option1" }
const _hoisted_19 = { class: "input-wrapper" }
const _hoisted_20 = {
  key: 1,
  class: "flex flex-column items-center justify-center flex-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_BaseButtonWithSpinner = _resolveComponent("BaseButtonWithSpinner")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Button = _resolveComponent("Button")!
  const _component_AdminPanelHeader = _resolveComponent("AdminPanelHeader")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_DropdownSelect = _resolveComponent("DropdownSelect")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      class: "admin-panel-fun-team-bidding__modal",
      visible: _ctx.showNewPresetModal,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.showNewPresetModal = $event))
    }, {
      header: _withCtx(() => [
        _hoisted_1
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_BaseButtonWithSpinner, {
          onClick: _ctx.addNewPreset,
          loading: _ctx.newPresetLoading
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('adminPanel.businessGame.boardConfig.apply')), 1)
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ]),
      default: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_Input, {
            modelValue: _ctx.newPresetName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.newPresetName = $event)),
            class: "p-inputtext-sm",
            onKeyup: _withKeys(_ctx.addNewPreset, ["enter"])
          }, null, 8, ["modelValue", "onKeyup"])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_AdminPanelHeader, {
      title: _ctx.$t('gamesCommon.customQuestions')
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            (_ctx.customQuestions.length)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  onClick: _ctx.addNew
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('gamesCommon.addNewCustomQuestion')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode("div", _hoisted_6, [
      (_ctx.customQuestions.length)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            (_ctx.customQuestions.length)
              ? (_openBlock(), _createBlock(_component_DataTable, {
                  key: 0,
                  class: "admin-panel-teambidding-custom-questions__all",
                  value: _ctx.customQuestions,
                  responsiveLayout: "scroll",
                  selection: _ctx.selectedQuestions,
                  "onUpdate:selection": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedQuestions = $event)),
                  onRowClick: _ctx.editQuestionFromRow
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      field: "id",
                      header: _ctx.$t('gamesCommon.id')
                    }, null, 8, ["header"]),
                    _createVNode(_component_Column, {
                      field: "textEn",
                      header: _ctx.$t('gamesCommon.questionEn')
                    }, null, 8, ["header"]),
                    _createVNode(_component_Column, {
                      field: "textPl",
                      header: _ctx.$t('gamesCommon.questionPl')
                    }, null, 8, ["header"]),
                    _createVNode(_component_Column, {
                      field: "type",
                      header: _ctx.$t('gamesCommon.type')
                    }, {
                      body: _withCtx((slotProps) => [
                        _createTextVNode(_toDisplayString(slotProps.data.type === 'multiple'
                ? _ctx.$t(`funTeamBidding.customQuestions.multiple`)
                : _ctx.$t(`funTeamBidding.customQuestions.yesNo`)), 1)
                      ]),
                      _: 1
                    }, 8, ["header"]),
                    _createVNode(_component_Column, {
                      field: "options",
                      header: _ctx.$t('gamesCommon.options')
                    }, {
                      body: _withCtx((slotProps) => [
                        (slotProps.data.options.some(v => v))
                          ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(slotProps.data.options.join(', ')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["header"]),
                    _createVNode(_component_Column, {
                      field: "validAnswer",
                      header: _ctx.$t('gamesCommon.validAnswer')
                    }, null, 8, ["header"]),
                    _createVNode(_component_Column, {
                      field: "actions",
                      header: _ctx.$t('gamesCommon.actions')
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode("i", {
                          class: "pi pi-trash",
                          onClick: ($event: any) => (_ctx.deleteCustomQuestion(slotProps.data.id))
                        }, null, 8, ["onClick"])
                      ]),
                      _: 1
                    }, 8, ["header"])
                  ]),
                  _: 1
                }, 8, ["value", "selection", "onRowClick"]))
              : _createCommentVNode("", true),
            (_ctx.customQuestions.length)
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('gamesCommon.editor')), 1),
                    _createVNode(_component_Button, {
                      class: "ml1",
                      onClick: _ctx.handleSaveCustomQuestion
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('gamesCommon.saveQuestion')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  (_ctx.questionEdited)
                    ? (_openBlock(), _createBlock("div", _hoisted_11, [
                        _createVNode("div", _hoisted_12, [
                          _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('gamesCommon.questionTextEn')), 1),
                          _createVNode(_component_Textarea, {
                            id: "text-en",
                            rows: "5",
                            modelValue: _ctx.questionEdited.textEn,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.questionEdited.textEn = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createVNode("div", _hoisted_14, [
                          _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('gamesCommon.questionTextPl')), 1),
                          _createVNode(_component_Textarea, {
                            id: "text-pl",
                            rows: "5",
                            modelValue: _ctx.questionEdited.textPl,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.questionEdited.textPl = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createVNode("div", _hoisted_16, [
                          _createVNode("label", null, _toDisplayString(_ctx.$t('gamesCommon.questionType')), 1),
                          _createVNode(_component_DropdownSelect, {
                            modelValue: _ctx.questionEdited.type,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.questionEdited.type = $event)),
                            options: _ctx.typeOptions,
                            "option-label": "label",
                            "option-value": "value",
                            onChange: _ctx.handleSetOptionsForQuestion
                          }, null, 8, ["modelValue", "options", "onChange"])
                        ]),
                        _createVNode("div", _hoisted_17, [
                          (_ctx.questionEdited.type === 'multiple')
                            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('gamesCommon.options')), 1),
                                _createVNode(_component_Input, {
                                  class: "my1",
                                  id: "option1",
                                  type: "text",
                                  modelValue: _ctx.questionEdited.options[0],
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.questionEdited.options[0] = $event))
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_Input, {
                                  class: "my1",
                                  id: "option2",
                                  type: "text",
                                  modelValue: _ctx.questionEdited.options[1],
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.questionEdited.options[1] = $event))
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_Input, {
                                  class: "my1",
                                  id: "option3",
                                  type: "text",
                                  modelValue: _ctx.questionEdited.options[2],
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.questionEdited.options[2] = $event))
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_Input, {
                                  class: "my1",
                                  id: "option4",
                                  type: "text",
                                  modelValue: _ctx.questionEdited.options[3],
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.questionEdited.options[3] = $event))
                                }, null, 8, ["modelValue"])
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.questionEdited.type === 'yesNo')
                            ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                _createVNode(_component_Input, {
                                  class: "my1",
                                  id: "option1yesNo",
                                  type: "text",
                                  modelValue: _ctx.questionEdited.options[0],
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.questionEdited.options[0] = $event))
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_Input, {
                                  class: "my1",
                                  id: "option2yesNo",
                                  type: "text",
                                  modelValue: _ctx.questionEdited.options[1],
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.questionEdited.options[1] = $event))
                                }, null, 8, ["modelValue"])
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("div", _hoisted_19, [
                          _createVNode("label", null, _toDisplayString(_ctx.$t('gamesCommon.validAnswerOne')), 1),
                          _createVNode(_component_DropdownSelect, {
                            modelValue: _ctx.questionEdited.validAnswer,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.questionEdited.validAnswer = $event)),
                            options: _ctx.questionEdited.options.map(item => ({ label: item, value: item })),
                            "option-label": "label",
                            "option-value": "value"
                          }, null, 8, ["modelValue", "options"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createBlock("div", _hoisted_20, [
            _createVNode("h3", null, _toDisplayString(_ctx.$t('gamesCommon.noCustomQuestions')), 1),
            _createVNode(_component_Button, { onClick: _ctx.addNew }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('gamesCommon.addNewCustomQuestion')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
    ])
  ], 64))
}